// グローバル変数
window.gSLANTED = [];
window.gSLANTED.isReadyYT = false;
window.gSLANTED.isLoaded = false;
window.YT = null;

const tagHTML = document.getElementsByTagName('html')[0];
const ua = navigator.userAgent.toLowerCase();
if (/iphone|ipad|macintosh|ipod/.test(ua) && 'ontouchend' in document) {
  tagHTML.classList.add('slanted-mobile');
  gSLANTED.isDevice = 'mobile';
  gSLANTED.isAndroid = false;
} else if (/android/.test(ua) && 'ontouchend' in document) {
  tagHTML.classList.add('slanted-mobile');
  gSLANTED.isDevice = 'mobile';
  gSLANTED.isAndroid = true;
} else {
  tagHTML.classList.add('slanted-pc');
  gSLANTED.isDevice = 'pc';
  gSLANTED.isAndroid = false;
}
